/**
 * Simple localStorage wishlist for product pages.
 */
(function () {
  const STORAGE_KEY = 'inga-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function initWishlistButton(button) {
    const productId = button.dataset.productId;
    if (!productId) return;

    const wishlist = getWishlist();
    const isSaved = wishlist.includes(productId);

    function setState(saved) {
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.textContent = saved ? 'Saved to wishlist' : 'Add to wishlist';
    }

    setState(isSaved);

    button.addEventListener('click', (event) => {
      event.preventDefault();
      let items = getWishlist();
      const alreadySaved = items.includes(productId);

      if (alreadySaved) {
        items = items.filter((id) => id !== productId);
      } else {
        items.push(productId);
      }

      saveWishlist(items);
      setState(!alreadySaved);
    });
  }

  document.querySelectorAll('[data-inga-wishlist]').forEach(initWishlistButton);
})();
